"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ResultPage =
/** @class */
function () {
  function ResultPage(model, items, pageInfo) {
    this.items = items;
    this.pageInfo = pageInfo;

    if (pageInfo.hasNextPage) {
      this.nextPage = function () {
        return model.fetch({
          after: pageInfo.endCursor
        });
      };
    }

    if (pageInfo.hasPreviousPage) {
      this.previousPage = function () {
        return model.fetch({
          before: pageInfo.startCursor
        });
      };
    }
  }

  return ResultPage;
}();

exports.ResultPage = ResultPage;